import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import '../switch/index.css';
var Switch = (function (_super) {
    tslib_1.__extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = function (e) {
            var _a = _this.props, onChange = _a.onChange, checked = _a.checked;
            var evt = tslib_1.__assign({}, e, { target: tslib_1.__assign({}, _this.props, { type: 'switch', checked: checked }) });
            onChange(evt);
        };
        return _this;
    }
    Switch.prototype.renderList = function () {
        var list = [];
        for (var i = 0; i < 8; i++) {
            list.push(React.createElement("div", { className: "zhui-switch-item", key: i },
                React.createElement("span", null)));
        }
        return list;
    };
    Switch.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, prefix = _b.prefix, checked = _b.checked, disabled = _b.disabled, text = _b.text, theme = _b.theme, others = tslib_1.__rest(_b, ["className", "prefix", "checked", "disabled", "text", "theme"]);
        var classes = cn(className, prefix, (_a = {},
            _a[prefix + "-disabled"] = disabled,
            _a[prefix + "-fold"] = !checked,
            _a[prefix + "-" + theme] = theme && theme !== 'default',
            _a));
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others, { onClick: this.toggle }),
            text && React.createElement("span", { className: "zhui-switch-text" }, text),
            this.renderList()));
    };
    Switch.defaultProps = {
        className: '',
        text: '',
        prefix: 'zhui-switch',
        checked: false,
        disabled: false,
        theme: 'default',
        onChange: function () { return null; }
    };
    return Switch;
}(React.Component));
export default Switch;
